<template>
  <div class="analysis">
    <div class="header">
      <span><i class="el-icon-arrow-left"></i></span>
      <span> 数据中心</span>
      <span><i class="el-icon-more"></i></span>
    </div>
    <div class="container">
      <div class="home_container_header">
        <div :class="['tab_list',{'active_tab_list':activeTabIndex==item.id}]" v-for="item in tabList" :key="item.id" @click="activeTab(item.id)">{{ item.name }}</div>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "Analysis",
  data() {
    return {
      tabList: [
        {
          name: "总览",
          id: 1,
        },
        {
          name: "作品分析",
          id: 2,
        },
        {
          name: "粉丝分析",
          id: 3,
        },
        {
          name: "收入分析",
          id: 4,
        },
      ],
      activeTabIndex: 1,
    };
  },
  components: {},
  created() {
    let route = this.$route;
    if (route.name == "generalView") {
      this.activeTabIndex = 1;
    } else if (route.name == "dataPanorama") {
      this.activeTabIndex = 2;
    } else if (route.name == "fansData") {
      this.activeTabIndex = 3;
    } else {
      this.activeTabIndex = 4;
    }
  },
  computed: {},

  methods: {
    activeTab(id) {
      this.activeTabIndex = id;
      switch (id) {
        case 1:
          this.$router.push("/training/generalView");
          break;
        case 2:
          this.$router.push("/training/dataPanorama");
          break;
        case 3:
          this.$router.push("/training/fansData");
          break;
        case 4:
          this.$router.push("/training/incomeData");
          break;
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.analysis {
  width: 100%;

  .header {
    width: 100%;
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    height: 46px;
    background: #fff;
    align-items: center;
    padding: 0 20px;
    font-size: 18px;
    font-weight: 600;
    box-sizing: border-box;
  }
  .container {
    width: 100%;
    overflow-y: auto;
    height: 100vh;
    padding-top: 46px;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .home_container_header {
      width: 100%;
      height: 50px;
      display: flex;
      background: #f5f5f5;
      justify-content: space-evenly;
      align-items: center;
      .tab_list {
        color: #646566;
        font-size: 14px;
        border-bottom: 2px solid transparent;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .active_tab_list {
        color: #323233;
        font-weight: 600;
        border-bottom: 2px solid #333;
      }
    }
    .content {
      width: 100%;
      // height: 300px;
      padding: 10px 0;
      padding-top: 0px;
      box-sizing: border-box;
      // .content_box {
      //   width: 100%;
      //   height: 300px;
      //   background: #fff;
      // }
    }
  }
}
</style>
  